import React, { useEffect, useState } from 'react';
import { View, StyleSheet, Image } from '@react-pdf/renderer';
import QRCode from 'qrcode';

import {
  TextBoldPlayFair,
  TextBoldWarranty,
  TextRegularWarranty
} from './TextWarranty';
import { ViewWarrantyRow } from './ViewWarranty';
import { colors } from 'src/constants';

interface Props {
  orderNo?: string;
  transactionNo?: string;
  storeBranch?: string;
  overrideOnURL?: string;
}

const styles = StyleSheet.create({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 5
  },
  qrContainer: {
    alignItems: 'center'
  },
  numbersContainer: {
    marginLeft: 2
  },
  image: {
    height: 30,
    width: 30
  },
  transactionNoText: {
    letterSpacing: 0.5,
    color: colors.red.A700,
    fontSize: 8
  },
  orderNoText: {
    letterSpacing: 0.5,
    color: '#ff0000',
    fontSize: 8
  },
  orderNoTextV2: {
    // letterSpacing: 0.5,
    // color: '#ff0000',
    fontSize: 9
  },
  o: {
    marginTop: -1
  },
  orderNum: {
    marginLeft: 4,
    fontSize: 8,
    marginTop: -1
  },
  orderNumV2: {
    marginLeft: 4,
    marginTop: -1
  },
  slipTxt: {
    fontSize: 10,
    letterSpacing: 1
  },
  slipTxtV2: {
    fontSize: 12,
    letterSpacing: 1
  },
  branchTxt: {
    fontSize: 9
  },
  emptyQr: {
    height: 30
  }
});

const component = ({
  transactionNo = '',
  orderNo = '',
  storeBranch = '',
  overrideOnURL = ''
}: Props) => {
  const [uriQR, setUriQR] = useState<string>('');

  const getTransactionNoUrl = () => {
    if (!transactionNo) return;
    QRCode.toDataURL(transactionNo, { errorCorrectionLevel: 'H' })
      .then((url) => setUriQR(url))
      .catch((err) => console.error(err));
  };

  useEffect(getTransactionNoUrl, []);

  return (
    <ViewWarrantyRow style={styles.root}>
      <View>
        {storeBranch && !overrideOnURL ? (
          <TextRegularWarranty style={styles.branchTxt}>
            PC Worth {`(${storeBranch})`}
          </TextRegularWarranty>
        ) : null}
        {overrideOnURL ? (
          <TextBoldWarranty style={styles.slipTxt}>
            WARRANTY SLIP
          </TextBoldWarranty>
        ) : (
          <TextBoldWarranty style={styles.slipTxtV2}>
            WARRANTY CARD
          </TextBoldWarranty>
        )}

        {overrideOnURL ? null : (
          <TextRegularWarranty style={styles.orderNoTextV2}>
            Quote No.: {`${transactionNo}`}
          </TextRegularWarranty>
        )}
      </View>
      <ViewWarrantyRow style={styles.qrContainer}>
        {uriQR && overrideOnURL ? (
          <Image style={styles.image} src={uriQR} />
        ) : (
          <View style={styles.emptyQr} />
        )}
        <View style={styles.numbersContainer}>
          {orderNo && overrideOnURL ? (
            <ViewWarrantyRow>
              <TextBoldPlayFair
                style={
                  overrideOnURL ? styles.orderNoText : styles.orderNoTextV2
                }
              >
                {`N`}
              </TextBoldPlayFair>
              <TextBoldPlayFair
                style={[
                  overrideOnURL ? styles.orderNoText : styles.orderNoTextV2,
                  styles.o
                ]}
              >
                {'ọ'}
              </TextBoldPlayFair>
              {overrideOnURL ? (
                <TextBoldPlayFair style={[styles.orderNoText, styles.orderNum]}>
                  {`${overrideOnURL}`}
                </TextBoldPlayFair>
              ) : (
                <TextBoldPlayFair
                  style={[styles.orderNoTextV2, styles.orderNumV2]}
                >
                  {`${orderNo}`}
                </TextBoldPlayFair>
              )}
            </ViewWarrantyRow>
          ) : null}
          {overrideOnURL ? (
            <TextBoldPlayFair style={styles.transactionNoText}>
              {transactionNo}
            </TextBoldPlayFair>
          ) : null}
        </View>
      </ViewWarrantyRow>
    </ViewWarrantyRow>
  );
};

export const RenderWarrantySlipTitle = React.memo(component);
